import api from './api';

export const standarPelayananService = {
    // PUBLIC
    getPublicStandar: async () => {
        try {
            const response = await api.get('/standar-pelayanan');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getStandarList: async (params = {}) => {
        try {
            const response = await api.get('/standar-pelayanan-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getStandar: async (id) => {
        try {
            const response = await api.get(`/standar-pelayanan-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createStandar: async (data) => {
        try {
            const response = await api.post('/standar-pelayanan-admin', data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    updateStandar: async (id, data) => {
        try {
            const response = await api.put(`/standar-pelayanan-admin/${id}`, data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    deleteStandar: async (id) => {
        try {
            const response = await api.delete(`/standar-pelayanan-admin/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/standar-pelayanan-admin/${id}/status`, { status });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },
};